import React from "react";
import "./optionBox.scss";
import { useNavigate } from "react-router-dom";

import NotificationBadge from "../../../../components/notificationBadge/NotificationBadge";

import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { isEmpty } from "../../../../utils/validation";

const OptionBox = ({
  icon,
  text,
  link,
  numberRequest = null,
  callback = null,
}) => {
  const navigate = useNavigate();

  return (
    <div
      className="option-box"
      onClick={() => {
        if (link) {
          navigate(link);
        } else if (callback) {
          callback();
        }
      }}
    >
      <div className="left-column">
        <div className="option-icon">
          {icon}
          {!isEmpty(numberRequest) ? (
            <NotificationBadge
              top={-8}
              right={-6}
              width={18}
              height={18}
              numberNotifications={numberRequest}
            />
          ) : null}
        </div>
        <div className="ms-3">{text}</div>
      </div>
      <div className="right-column">
        <ArrowForwardRoundedIcon />
      </div>
    </div>
  );
};

export default OptionBox;
